import 'scss/services/medicalDictation.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { config } from 'config'
import * as userApi from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'
$(function () {
  serviceQA()
  serviceTopbar()
  $('#applyNow').click(function () {
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(`${config.CONSOLE}workorder/commit?category=431ebb90152643899aeab75c0d6fd536&tid=efde83e6c0ed45138c18569fef648825&categoryName=医疗听写SDK&tname=商务接洽&title=医疗听写SDK - 服务申请&id=medicalDictation`)
      }
    })
  })
  $('.service-topbar-open-btn').click(function () {
    var $this = $(this)
    var href = $this.data('href')
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(href)
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/medicalDictation.js